import { IconName } from 'components_new/atoms/Icon'

import NodeType from 'types/transformation/enums/NodeType'

export interface CatalogItem {
  type: NodeType
  title: string
  icon: IconName
  description: string
}

export interface CatalogGroup {
  group: string
  items: CatalogItem[]
}

/**
 * The set of node types a user can add to a transformation, grouped for the
 * palette rail. The MAP (Output) node is intentionally absent — it is the
 * table's fixed output and is not user-addable.
 */
export const NODE_CATALOG: CatalogGroup[] = [
  {
    group: 'Input',
    items: [
      {
        type: NodeType.INPUT,
        title: 'Input',
        icon: 'LoginOutlined',
        description: 'Laddar in data från en tabell.'
      }
    ]
  },
  {
    group: 'Transformering',
    items: [
      {
        type: NodeType.DATE_PARSER,
        title: 'Date parser',
        icon: 'EventAvailableOutlined',
        description: 'Konverterar textelement till önskat datumformat.'
      },
      {
        type: NodeType.FILTER,
        title: 'Filter',
        icon: 'Filter',
        description: 'Filtrerar dataset efter ett visst villkor.'
      },
      {
        type: NodeType.LEFT_JOIN,
        title: 'Left join',
        icon: 'JoinLeft',
        description: 'Lägger ihop två tabeller genom en gemensam kolumn.'
      },
      {
        type: NodeType.UNITE,
        title: 'Unite',
        icon: 'DeviceHubOutlined',
        description: 'Laddar in poster från två tabeller i samma dataset.'
      },
      {
        type: NodeType.CAST,
        title: 'Cast',
        icon: 'RuleOutlined',
        description: 'Ändra datatyp för en kolumn'
      },
      {
        type: NodeType.CLEAR,
        title: 'Clear',
        icon: 'RuleOutlined',
        description: 'Väljer bort kolumner som inte används.'
      },
      {
        type: NodeType.AGGREGATE,
        title: 'Aggregate',
        icon: 'TuneOutlined',
        description: 'Aggregerar data baserat på vald funktion.'
      },
      {
        type: NodeType.CONCATENATE,
        title: 'Concatenate',
        icon: 'Merge',
        description: 'Skapa ny kolumn genom att sammanfoga två kolumner.'
      },
      {
        type: NodeType.TIME_DIFFERENCE,
        title: 'Time difference',
        icon: 'TimerOutlined',
        description: 'Beräknar tidsskillnaden mellan två datum.'
      },
      {
        type: NodeType.REPLACE,
        title: 'Replace',
        icon: 'SwapHorizOutlined',
        description: 'Ersätt värden i en kolumn.'
      },
      {
        type: NodeType.CALCULATE,
        title: 'Calculate',
        icon: 'Calculation',
        description: 'Räkna ut värde.'
      },
      {
        type: NodeType.LOWER,
        title: 'Lower',
        icon: 'TransformOutlined',
        description: 'Gör en kolumn till lowercase.'
      },
      {
        type: NodeType.TRIM,
        title: 'Trim',
        icon: 'TransformOutlined',
        description: 'Trimma en kolumn'
      },
      {
        type: NodeType.TEXT_REPLACE,
        title: 'Text replace',
        icon: 'TextReplace',
        description: 'Sök och ersätt text i en kolumn med regex.'
      }
    ]
  }
]
